export const Loading = () => {
  return (
    <div className="fixed flex h-full w-full z-50">
      <div className="m-auto select-none">
        <img className="-mt-16 -ml-8 h-16 w-24" src="/assets/images/loading.gif" alt="loading" />
      </div>
    </div>
  );
};
